'use es6';

import { QUOTE_PROPERTIES } from 'reference-resolvers/constants/CacheKeys';
import { getQuoteProperties, createGetQuoteProperties } from 'reference-resolvers/api/PropertiesAPI';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
export const createQuotePropertyReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: QUOTE_PROPERTIES,
  createFetchData: createGetQuoteProperties,
  fetchData: getQuoteProperties
}, options));
export default createQuotePropertyReferenceResolver();